<template>
  <div id="userLogin">
    <div>
      <div class="big-img">
        <img src="./../../assets/yema-big.jpg" alt="" class="yema-big-img">
      </div>
      <h2>
        <!-- <img src="./../../assets/yema.jpg" alt="" class="yema-img"> -->
        <span>请输入接入号/ICCID号/手机号</span>
      </h2>
      <form>
        <div>
          <keep-alive>
            <se-autocomplete
              v-model="iccid"
              :fetchsuggestions="querySearch"
              placeholder="接入号/ICCID号/手机号"
              @select="handleSelect"
            />
          </keep-alive>
        </div>
        <div class="formLine">
          <mt-button
            type="primary"
            size="large"
            @click.prevent="userQuerySIM"
          >查询</mt-button>
        </div>
      </form>
      <br>
      <!-- <br/>
                 <div class="formLine">
                    <mt-button type="primary" size="large" @click.prevent="buyCardapp">安卓APP下载</mt-button>
                     <br/>
                      <br/>
                      <mt-button type="primary" size="large" @click.prevent="buyCardapp1">苹果APP下载</mt-button>
                </div> -->
    </div>
    <div>
      <!-- <p>
                云南全省,广西全省,新疆全省
西藏全省,
福建全省,
海南全省,
广东省茂名市,
广东省清远市。
<br/>
<p style="color:red">以上地区禁止使用!! </p>
<br/>
运营商电子围栏系统扫到在以上地区使用直接注销
            </p> -->
    </div>
    <!-- 图片实名认证 -->
    <van-dialog
      v-model="isShow"
      title="微信识别二维码 在浏览器下载"
      show-cancel-button
    >
      <img style="width: 100%" src="@/assets/app.png">
    </van-dialog>
    <!-- <mt-button type="primary"  style="width:200px;margin:50px auto;" size="large" @click.prevent="goBuyCard">点击此处购卡</mt-button> -->

    <!-- <img style="width: 100%; margin-top: 2rem;" src="@/assets/app.png" alt="" /> -->

    <!-- <Advertisement></Advertisement> -->
  </div>
</template>
<script>
import { Dialog } from 'vant'
import { Toast } from 'vant'
import { wxRequest } from '@/api/user.js'
import SeAutocomplete from '@/components/SeAutocomplete'
import Advertisement from '@/components/Advertisement'
export default {
  components: { SeAutocomplete, Advertisement },
  data() {
    return {
      isShow: false,
      iccid: '',
      code: '',
      showAds: true,
      gzh: '',
      realNameList: [
        '1192351241053663232',
        '1224969664338063360',
        '1255666672321163264',
        '7DA692EC992B45E297450F40DEDC5614',
        '8601954A2B074E80AACAAF32C5EE232C',
        '960F3276EFAA4ED2999754895F4BCCB4',
        'B1E112B9F1D8420E9072D9F47D6A135E',
        '1296725794797645824',
        '1351015790979051520',
        '1437669615726489600',
        '1446408571309780992',
        '1274979554988912640',
        '1279289937396494336',
        '1209750973904318464',
        '1340547268712853504',
        '1342411677588516864',
        '1352472847720640512',
        '1195548743236055040',
        '1390194557349523456',
        '1410067527249162240'
      ],
      suolangList: ['1275704520822747136'],
      sulangPool: ['1370553646319661056'],
      authList: [
        '1428196300137951232',
        '1424315594500468736',
        '1418065148626595840',
        '1392003846057750528',
        '1382231170900553728',
        '1511665912472662016',
        '1511665823104626688',
        '1559896178252836864',
        '1570631203634016256',
        '1570264863702249472',
        '1574343890884882432',
        '1369825332332326912',
        '1437239059750580224',
        '1437238992062902272',
        '1437985184350728192',
        '1438333231702208512',
        '1442373184853635072',
        '1446317354739822592'
      ]
    }
  },
  created() {
    var source = this.getQueryVariable('source')
      ? this.getQueryVariable('source')
      : process.env.VUE_APP_APPID
    localStorage.setItem('appid', source)
    localStorage.setItem('isHeadquarterAppid', false)
    var appid = source || process.env.VUE_APP_APPID

    console.log(appid)
    var redirectUrl = window.location.href
    var index = redirectUrl.indexOf('code')
    redirectUrl = encodeURIComponent(redirectUrl)
    if (index < 0) {
      window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirectUrl}&response_type=code&scope=snsapi_userinfo#wechat_redirect`
    } else {
      var search = window.location.search
      console.log('search', search)
      var startIndex = search.indexOf('code')
      var endIndex = search.indexOf('&', startIndex)
      var str = search.slice(startIndex, endIndex)
      var code = str.slice(str.indexOf('=') + 1)
      this.code = code
      this.iccid = localStorage.getItem('recordLoginText')

    // 自动登录
    // if(this.iccid){
    //     this.userQuerySIM();
    // }
    }

    // 获取总部公众号appid
    // wxRequest('/sim/appId', {}, 'post').then((res) => {
    //   if (res.data.code == 200) {
    //     if (appid != res.data.data.collectAppid) {
    //       this.$store.commit('setIsHeadquarterAppid', 'false')
    //       localStorage.setItem('isHeadquarterAppid', false)
    //     } else {
    //       this.$store.commit('setIsHeadquarterAppid', 'true')
    //       localStorage.setItem('isHeadquarterAppid', true)
    //     }
    //   }
    // })
     this.$store.commit('setIsHeadquarterAppid', 'true');
     localStorage.setItem('isHeadquarterAppid', true);
  },

  mounted() {},
  methods: {
    buyCardapp() {
      this.$router.push({
        path: '/user/AppLoad',
        query: {
          realNameCard: 1
        }
      })
    },
    buyCardapp1() {
      this.$router.push({
        path: '/user/AppLoadp',
        query: {
          realNameCard: 1
        }
      })
    },
    querySearch(queryString, cb) {
      var listAll = this.getAutoCompleteData('iccidList')
      var results = queryString
        ? listAll.filter(this.createFilter(queryString))
        : listAll
      cb(results)
    },
    createFilter(queryString) {
      return (listAll) => {
        return listAll.indexOf(queryString) == 0
      }
    },
    handleSelect(item) {
      this.iccid = item
    },
    userQuerySIM1() {
      this.isShow = true
    },
    userQuerySIM() {
      if (this.iccid == '') {
        Dialog.alert({ title: '提示', message: '请输入ICCID号' })
        return false
      }

      const recordLoginText = this.iccid // 存放用户登录时输入的文本，将用于首页显示

      const data = {
        requestId: this.iccid,
        code: this.code,
        app: '1'
      }
      wxRequest('sim/bind', data, 'get').then((res) => {
        if (res.data.code == 200) {
          const record = res.data.data
          const iccid = record.iccid

          localStorage.setItem('mobile', record.mobile)
          localStorage.setItem('supplierTypeName', record.supplierTypeName)
          localStorage.setItem('wxHeadImg', record.wxHeadImg)
          localStorage.setItem('wxNickName', record.wxNickName)
          localStorage.setItem('recordLoginText', recordLoginText)
          localStorage.setItem('supplierName', record.supplierName)
          localStorage.setItem('iccid', iccid)
          localStorage.setItem('intoNo', record.intoNo)
          localStorage.setItem('openId', record.openId)
          localStorage.setItem('isSale', record.isSale)
          localStorage.setItem('ishavePkg', record.ishavePkg)
          localStorage.setItem('ishavePrice', record.ishavePrice)
          localStorage.setItem('priceImgUrl', record.priceImgUrl)
          this.$store.state.recordLoginText = recordLoginText
          this.$store.state.supplierCode = res.data.data.supplierCode
          this.$store.state.iccid = iccid

          if (record.isSale == 1 && record.ishavePrice == 0) {
            this.$router.replace('/user/simOpen')
          }

          this.$store.state.intoNo = record.intoNo
          this.setAutoCompleteData('iccidList', recordLoginText, 10)
          // 未实名的电信卡用户（通过cardType字段判断），实名认证时将只需要绑定
          const cardType = record.supplierCode
          // if(this.realNameList.indexOf(cardType) > -1){
          //     let _data = { iccid: record.iccid }
          //     wxRequest("bindPhone/state", _data, "post").then(res => {
          //         if(res.data.code == 200){
          //             let result = res.data.data;
          //             localStorage.setItem('applyChangeSimState', result.applyChangeSimState);
          //             if(result.bindState == 2){
          //                 this.$router.push({
          //                     path:'/user/bindPhone',
          //                     query:{
          //                         iccid: record.iccid
          //                     }
          //                 });
          //             }else{
          //                 localStorage.setItem('phoneNo', result.userPhone);
          //                 this.$router.replace('/user/home');
          //             }
          //         }else{
          //             Dialog.alert({title: '提示', message:res.data.message});
          //         }
          //     })
          // }else if(this.authList.indexOf(cardType) > -1){
          //     let _data = { iccid: record.iccid }
          //     wxRequest("bindPhone/state", _data, "post").then(res => {
          //         if(res.data.code == 200){
          //             let result = res.data.data;
          //             localStorage.setItem('applyChangeSimState', result.applyChangeSimState);
          //             if(result.bindState == 2){
          //                 this.$router.push({
          //                     path:'/user/bindPhone1',
          //                     query:{
          //                         iccid: record.iccid
          //                     }
          //                 });
          //             }else{
          //                 localStorage.setItem('phoneNo', result.userPhone);
          //                 this.$router.replace('/user/home');
          //             }
          //         }else{
          //             Dialog.alert({title: '提示', message:res.data.message});
          //         }
          //     })
          // }else if(this.suolangList.indexOf(cardType) > -1){
          //     window.location.href = `http://wx.iot688.com/iot/iotSimfind?cn=${iccid}&yurlyb=wx.swwxy.cn/#/user/home`
          // }else if(this.sulangPool.indexOf(cardType) > -1){
          //     window.location.href = `http://clt.iot688.com/iot/iotSimfind?cn=${iccid}&yurlyb=wx.swwxy.cn/#/user/home`
          // }
          if (record.isBind == 1) {
            this.$router.push({
              path: '/user/bindPhone1',
              query: {
                iccid: record.iccid
              }
            })
          } else if (record.isBind == 2) {
            this.$router.push({
              path: '/user/bindPhone',
              query: {
                iccid: record.iccid
              }
            })
          } else {
            this.$router.replace('/user/home')
          }
        } else {
          Dialog.alert({ title: '提示', message: res.data.message })
        }
      })
    },

    // 获取url参数
    getQueryVariable(variable) {
      var query = window.location.search.substring(1)
      var vars = query.split('&')
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split('=')
        if (pair[0] == variable) {
          return pair[1]
        }
      }
      return false
    },

    goBuyCard() {
      window.location.href = 'http://wx.swwxy.cn/#/user/login2'
    }

    // goto(path){
    //     //广告点击统计
    //     wxRequest("link/click",{url: path}, "get").then(res => {
    //         window.location.href = path;
    //     });

    // },
  },

  beforeDestory() {}
}
</script>

<style scoped lang="less">
.big-img {
  text-align: center;
}
.yema-big-img {
  height: 100px;
}
// h2 {
//     display: flex;
//     align-items: center;
//     .yema-img {
//         height: 20px;
//         padding-right: 3px;
//     }
// }
</style>
